import { eTypePickingRoute } from '../../enums/eTypePickingRoute'
import { Zone } from '../../interfaces'
import {
  IPickingRouteState,
  IPickingRouteValidationState
} from '../../interfaces/PickingRoute/PickingRouteState'
import { PickingRoute } from '../../interfaces/PickingRouteAdmin/PickingRoute'
import { utcToLocal } from '../../utils/dateHelper'
import { TableHeaderConfigWithType } from '../_EOS/Table'

export const pickingRouteTableHeaderConfig = (
  zones: Zone[] | undefined,
  pickingRouteStates: IPickingRouteState[],
  pickingRouteValidationStates: IPickingRouteValidationState[]
) => {
  const table: TableHeaderConfigWithType<PickingRoute>[] = [
    {
      field: 'pickingRouteId',
      title: 'Ruta',
      formater: (_pickingRouteId: number | string, row) =>
        formatPickingRouteId(row!)
    },
    {
      field: 'createdAt',
      title: 'Creada',
      formater: (createdAt) => utcToLocal(createdAt.toString(), 'dd/MM/yyyy')
    },
    { field: 'username', title: 'Usuario' },
    {
      field: 'zoneId',
      title: 'Zona',
      formater: (zoneId) =>
        zones?.filter((el) => el.zoneId === zoneId)[0]?.zoneName || 'Sin Zona'
    },
    {
      field: 'pickingRouteStateId',
      title: 'Estado Picking',
      formater: (pickingStatusId) =>
        pickingRouteStates.filter((el) => el.value === pickingStatusId)[0]
          ?.name || ''
    },
    {
      field: 'pickingValidationStateId',
      title: 'Estado Validación',
      formater: (validationStatusId) =>
        pickingRouteValidationStates.filter(
          (el) => el.value === validationStatusId
        )[0]?.name || ''
    },
    { field: 'lpn', title: 'LPN' }
  ]

  return table
}

function formatPickingRouteId(row: PickingRoute) {
  const pickingRouteId =
    row.typePickingRouteId === eTypePickingRoute.RTV
      ? `RTV${row.pickingRouteId}`
      : row.pickingRouteId
  return pickingRouteId.toString()
}
